import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Formik, Form, FormikHelpers } from "formik";
import { object, string } from "yup";
import EditDobProofMaster, {
  EditDobProofMasterInitialValues,
} from "./EditDobProofMaster";
import {
  useUpdateDobProofMasterMutation,
  useGetDobProofMasterByIdQuery,
} from "src/services/DobProofMasterService";
import { showToast } from "src/utils/toaster/showToast";
import { useNavigate } from "react-router-dom";
import { DobProofMasterResponse } from "src/models/DobProofMaster.model";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import ATMPageLoader from "src/components/UI/atoms/ATMPageLoader/ATMPageLoader";

const EditDobProofMasterWrapper = () => {
  const [dobProofData, setDobProofData] =
    useState<DobProofMasterResponse | null>(null);
  const { dobProofId } = useParams();

  const navigate = useNavigate();
  const [updateDobProofMaster] = useUpdateDobProofMasterMutation();

  const { data, isLoading, isFetching } = useGetDobProofMasterByIdQuery(
    dobProofId || ""
  );

  const initialValues: EditDobProofMasterInitialValues = {
    name: dobProofData?.name || "",
    documentRequired: dobProofData?.documentRequired ?? true,
    numberOfDocumentsRequired: dobProofData?.numberOfDocumentsRequired ?? 1,
    documentLabels: dobProofData?.documentLabels || [""],
  };

  useEffect(() => {
    if (!isFetching && !isLoading) {
      setDobProofData(data?.data || null);
    }
  }, [isLoading, isFetching, data]);

  const validationSchema = object({
    name: string().required("Name is required"),
  });

  const handleSubmit = (
    values: EditDobProofMasterInitialValues,
    { setSubmitting }: FormikHelpers<EditDobProofMasterInitialValues>
  ) => {
    updateDobProofMaster({
      id: dobProofId,
      body: values,
    }).then((res: any) => {
      if (res.error) {
        showToast("error", res?.error?.data?.message);
        setSubmitting(false);
      } else {
        showToast("success", res?.data?.message);
        navigate("/dob-proof-master");
        setSubmitting(false);
      }
    });
  };

  if (isFetching || isLoading) {
    return <ATMPageLoader />;
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <SideNavLayout>
          <Form className="h-full">
            <EditDobProofMaster formikProps={formikProps} />
          </Form>
        </SideNavLayout>
      )}
    </Formik>
  );
};

export default EditDobProofMasterWrapper;
